// extracted by mini-css-extract-plugin
export default {"left-col":"left-col_LOeUc","right-col":"right-col_v8eWb","filter-bar":"filter-bar_nBAsg","coupon-list-space":"coupon-list-space_Y1XSD"};